import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/popup-calender-clock.svg'
import _imports_1 from '../../../assets/icons/popup-calender-calender.svg'
import _imports_2 from '../../../assets/icons/yellow-location-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-1690800d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal_card_content tw-mt-4 tw-flex tw-flex-col tw-gap-4" }
const _hoisted_2 = { class: "login_wrapper_points tw-flex tw-flex-col tw-gap-2" }
const _hoisted_3 = { class: "form-container-list !tw-flex !tw-items-center !tw-gap-2" }
const _hoisted_4 = { class: "login_wrapper_points tw-flex tw-flex-col tw-gap-2" }
const _hoisted_5 = { class: "form-container-list !tw-flex !tw-items-center !tw-gap-2" }
const _hoisted_6 = { class: "login_wrapper_points tw-flex tw-flex-col tw-gap-2" }
const _hoisted_7 = { class: "form-container-list !tw-flex !tw-items-center !tw-gap-2" }
const _hoisted_8 = { class: "card__buttons tw-flex tw-flex-col tw-gap-2 tw-items-center tw-justify-center tw-w-1/2 md:tw-w-full" }
const _hoisted_9 = { class: "yellow-text" }
const _hoisted_10 = {
  key: 1,
  class: "calendar__wrapper tab__area__wrapper"
}
const _hoisted_11 = { class: "tab__area__blocks" }
const _hoisted_12 = { class: "tab__area__left__block" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tab__area__title" }, "Select your preferred course date", -1))
const _hoisted_14 = { class: "custom__calender__date" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "event__list" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "calendar__event tw-h-[60px] tw-overflow-auto tw-p-[5px] tw-relative" }
const _hoisted_19 = { class: "calendar__event__title tw-flex tw-items-center tw-gap-1" }
const _hoisted_20 = { class: "mod-popup__content" }
const _hoisted_21 = { class: "mod-popup__content-inner" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mod-popup__content-heading" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Course Details")
], -1))
const _hoisted_23 = { class: "mod-popup__content-title" }
const _hoisted_24 = { class: "mod-popup__content-info" }
const _hoisted_25 = { class: "mod-popup__content-info-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_27 = { class: "mod-popup__content-info-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_29 = { class: "mod-popup__content-location" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Location", -1))
const _hoisted_31 = { class: "mod-popup__content-location-text" }
const _hoisted_32 = { class: "tab__area__right__block" }
const _hoisted_33 = { class: "content" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Upcoming Courses"),
  /*#__PURE__*/_createElementVNode("p", { class: "description" }, [
    /*#__PURE__*/_createTextVNode(" Please select the best suited course "),
    /*#__PURE__*/_createElementVNode("strong", null, "date"),
    /*#__PURE__*/_createTextVNode(" & "),
    /*#__PURE__*/_createElementVNode("strong", null, "location"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1))
const _hoisted_35 = {
  key: 0,
  class: "location__name__wrapper"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Location")
], -1))
const _hoisted_37 = { class: "location__city" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab__area__list__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "open-logo tw-min-w-[18px] tw-max-w-[18px] tw-min-h-[20px] tw-max-h-[20px]",
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_39 = {
  key: 1,
  class: "location__city"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab__area__list__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "open-logo",
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No selected address filter", -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = {
  key: 1,
  class: "location__name__wrapper tw-flex tw-flex-col tw-gap-4"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Locations")
], -1))
const _hoisted_45 = { class: "tw-flex tw-flex-col tw-gap-2" }
const _hoisted_46 = { class: "postcode__wrapper !tw-h-[300px]" }
const _hoisted_47 = { class: "address__postcodes !tw-gap-0" }
const _hoisted_48 = { class: "tab__area__candidate__card" }
const _hoisted_49 = { class: "candidate_list__card" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card_header" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Candidates")
], -1))
const _hoisted_51 = { class: "candidate_list__card__content" }
const _hoisted_52 = { class: "candidate_list__item" }
const _hoisted_53 = { class: "candidate_list__profile" }
const _hoisted_54 = { class: "profile__img" }
const _hoisted_55 = { class: "action_wrapper" }
const _hoisted_56 = {
  key: 0,
  class: "candidate_chip"
}
const _hoisted_57 = {
  key: 1,
  class: "candidate_chip"
}
const _hoisted_58 = {
  key: 0,
  class: "tab__area__card"
}
const _hoisted_59 = { class: "title" }
const _hoisted_60 = { class: "yellow-text" }
const _hoisted_61 = { class: "tw-flex tw-flex-col tw-items-start" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Add me to the live queue.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoBlueIcon = _resolveComponent("InfoBlueIcon")!
  const _component_Text = _resolveComponent("Text")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_CoursesListView = _resolveComponent("CoursesListView")!
  const _component_CourseEnrollModal = _resolveComponent("CourseEnrollModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isShowPaymentDialog)
      ? (_openBlock(), _createBlock(_component_CommonDialog, {
          key: 0,
          HeaderTittle: "Is an iknowa course 100% for you?",
          title: "You're one small step away from unleashing your green building superpowers!",
          className: ['enrollment__wrapper'],
          onClickBackButton: _ctx.onClickBackButton
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_InfoBlueIcon),
                  _createVNode(_component_Text, {
                    variant: "h6",
                    textWeight: "600"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Attendance")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_Text, {
                  variant: "h6",
                  textWeight: "500",
                  textColor: "rgba(12, 15, 74, 0.5)",
                  alineHeight: "20px"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Committing to all 10 course days.")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_checkbox, {
                  modelValue: _ctx.modelOption1,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelOption1) = $event))
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_Text, {
                      variant: "p",
                      textWeight: "600"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("I accept & agree to the above")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_InfoBlueIcon),
                  _createVNode(_component_Text, {
                    variant: "h6",
                    textWeight: "600"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Passing the Exam")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_Text, {
                  variant: "h6",
                  textWeight: "500",
                  textColor: "rgba(12, 15, 74, 0.5)",
                  alineHeight: "20px"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Just like any hero needs to show up for training, so do you! Attending all ten course sessions is key to unlocking your full potential!")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_checkbox, {
                  modelValue: _ctx.modelOption2,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelOption2) = $event))
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_Text, {
                      variant: "p",
                      textWeight: "600"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("I accept & agree to the above")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_InfoBlueIcon),
                  _createVNode(_component_Text, {
                    variant: "h6",
                    textWeight: "600"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Level up")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_Text, {
                  variant: "h6",
                  textWeight: "500",
                  textColor: "rgba(12, 15, 74, 0.5)",
                  alineHeight: "20px"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Take your learning to the next level by completing three projects on iknowa. It's a win-win – you gain experience and get to showcase your skills to clients!")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_checkbox, {
                  modelValue: _ctx.modelOption3,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelOption3) = $event))
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_Text, {
                      variant: "p",
                      textWeight: "600"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("I accept & agree to the above")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_v_btn, {
                  class: "button button-orange",
                  width: "auto",
                  size: "large",
                  block: "",
                  loading: _ctx.loading,
                  disabled: !_ctx.modelOption1 || !_ctx.modelOption2 || !_ctx.modelOption3,
                  onClick: _ctx.onClickAcceptAndEnroll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" accept & enroll ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"]),
                _createElementVNode("div", _hoisted_9, [
                  _createTextVNode(" Read Full Terms & Conditions "),
                  _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClickBackButton"]))
      : _createCommentVNode("", true),
    (_ctx.isShowCalenderView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "blue-text",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickBackCoursesButton && _ctx.onClickBackCoursesButton(...args)))
          }, [
            _createVNode(_component_v_icon, { icon: "mdi-chevron-left" }),
            _createTextVNode("Back to Courses ")
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_Calendar, {
                ref: "calendarRef",
                "title-position": "left",
                class: "custom__calendar",
                masks: _ctx.masks,
                color: "sky-blue",
                "trim-weeks": "",
                transparent: "",
                attributes: _ctx.calendarAttributes,
                modelValue: _ctx.selectedDate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDate) = $event)),
                expanded: "",
                "min-date": _ctx.currentMonthStartDate
              }, {
                "day-content": _withCtx(({ day, attributes }) => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["day-label", { 'today-date': day.isToday }])
                    }, _toDisplayString(day.day), 3),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes, (attr) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: attr.id,
                                class: _normalizeClass(["custom__calender__event__day !tw-h-auto !tw-p-0 !tw-overflow-visible tw-flex tw-flex-col tw-justify-center tw-gap-3 tw-relative group", { 'is-active': _ctx.courseScheduleId === attr.id }]),
                                onClick: ($event: any) => (_ctx.onClickSelectCourse(attr))
                              }, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, [
                                    (attr.course?.name)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          icon: "mdi-record"
                                        }))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(attr?.course?.name), 1)
                                  ]),
                                  _createVNode(_component_Text, {
                                    class: "tw-text-[10px]",
                                    textColor: "rgba(12, 15, 74, 0.5)"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("spot(s) available: " + _toDisplayString(attr?.allotedSpot < attr?.spotLimit
                                ? attr?.spotLimit - attr?.allotedSpot
                                : "Full"), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createVNode(_component_v_menu, {
                                  persistent: false,
                                  "close-on-content-click": false,
                                  "scroll-strategy": "close",
                                  "open-on-hover": _ctx.isDesktop,
                                  location: "end"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_20, [
                                      _createElementVNode("div", _hoisted_21, [
                                        _hoisted_22,
                                        _createElementVNode("div", _hoisted_23, [
                                          _createElementVNode("p", null, _toDisplayString(attr?.course?.name), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_24, [
                                          _createElementVNode("div", _hoisted_25, [
                                            _hoisted_26,
                                            _createElementVNode("p", null, _toDisplayString(_ctx.extractTime(attr.startDate)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_27, [
                                            _hoisted_28,
                                            _createElementVNode("ul", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedWeeks(
                                        attr.courseScheduleWeeks
                                      ), (week, i) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                  key: week.id
                                                }, " Week:" + _toDisplayString(i + 1) + " " + _toDisplayString(_ctx.formatDate(week?.weekStartDate)) + " - " + _toDisplayString(_ctx.formatDate(week?.weekEndDate)), 1))
                                              }), 128))
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                          _hoisted_30,
                                          _createElementVNode("div", _hoisted_31, [
                                            _createElementVNode("p", null, _toDisplayString(attr?.location?.lookUpAddress), 1)
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["open-on-hover"])
                              ], 10, _hoisted_17))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["masks", "attributes", "modelValue", "min-date"])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_v_card, { class: "tab__area__right__block__card" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    (!_ctx.isShowAddressList)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _hoisted_36,
                          (_ctx.selectedAddress.length)
                            ? (_openBlock(), _createBlock(_component_v_select, {
                                key: 0,
                                items: _ctx.selectedAddress,
                                "item-title": "address",
                                "item-value": "id",
                                modelValue: _ctx.selectedItem,
                                "onUpdate:modelValue": [
                                  _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedItem) = $event)),
                                  _ctx.onSelectAddress
                                ],
                                density: "compact",
                                variant: "outlined",
                                "menu-props": { contentClass: 'text__selector' },
                                class: "input_field_selector",
                                "return-object": ""
                              }, {
                                selection: _withCtx(({ item }) => [
                                  _createElementVNode("div", _hoisted_37, [
                                    _hoisted_38,
                                    _createElementVNode("p", null, _toDisplayString(item.props.title), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true),
                          (!_ctx.selectedAddress.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_42))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isShowAddressList)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _hoisted_44,
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_v_text_field, {
                              density: "compact",
                              variant: "outlined",
                              class: "c-input rounded-full !tw-mt-0 !tw-mb-0",
                              modelValue: _ctx.selectedAddress,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedAddress) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("ul", _hoisted_47, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressListFromCourse, (item, index) => {
                                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: _ctx.selectedAddress,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedAddress) = $event)),
                                      value: item
                                    }, {
                                      label: _withCtx(() => [
                                        _createVNode(_component_Text, {
                                          variant: "xsmall",
                                          textWeight: "600",
                                          lineHeight: "20px"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.address), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "value"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createElementVNode("div", _hoisted_51, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUpdatedMembers, (candidate, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "candidate_list__card__user",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_52, [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.assignedMembers,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.assignedMembers) = $event)),
                                onChange: ($event: any) => (_ctx.handleChange(candidate)),
                                color: "#4B4BFF",
                                value: candidate?.toUser?.id
                              }, null, 8, ["modelValue", "onChange", "value"])
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _createVNode(_component_UserProfileLogo, {
                                  userName: 
                          candidate?.userName || candidate?.email?.split('@')[0]
                        
                                }, null, 8, ["userName"])
                              ]),
                              _createElementVNode("p", null, _toDisplayString(candidate?.toUserId
                          ? `${candidate?.toUser?.firstName} ${candidate?.toUser?.lastName}`
                          : candidate?.email?.split("@")[0]), 1)
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              (candidate?.isWorkStationAdmin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, " Admin "))
                                : (_openBlock(), _createElementBlock("div", _hoisted_57, "User"))
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  (_ctx.enrollCourseName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createElementVNode("h6", _hoisted_59, _toDisplayString(_ctx.enrollCourseName ? _ctx.enrollCourseName : _ctx.courseDetails?.name), 1),
                        _createElementVNode("span", _hoisted_60, "Starting date: " + _toDisplayString(_ctx.enrollCourseStartDate
                  ? _ctx.formattedStartDate(_ctx.enrollCourseStartDate)
                  : _ctx.formattedStartDate(
                      _ctx.courseDetails?.courseSchedules[0]?.startDate
                    )), 1),
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_component_Text, {
                            variant: "span",
                            textWeight: "600"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Spots available: "),
                              _createVNode(_component_Text, {
                                variant: "span",
                                textColor: "#FAA500"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.spotsRemaining ? _ctx.spotsRemaining : "Full"), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Text, {
                            variant: "span",
                            textWeight: "600"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Location: " + _toDisplayString(_ctx.enrollCourseAddress
                    ? _ctx.enrollCourseAddress
                    : _ctx.courseDetails?.courseSchedules[0]?.address), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_checkbox, {
                    modelValue: _ctx.option1,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.option1) = $event)),
                    class: "tab__area__checkbox",
                    color: "#4B4BFF",
                    value: "#4B4BFF"
                  }, {
                    label: _withCtx(() => [
                      _hoisted_62,
                      _createVNode(_component_v_icon, { icon: "mdi-information" })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_v_btn, {
                    class: "button button-purple",
                    onClick: _ctx.onClickConfirmMyEnrollment,
                    disabled: _ctx.isEnrollDisable,
                    loading: _ctx.enrollLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("confirm enrollment ")
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled", "loading"])
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createBlock(_component_CoursesListView, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.isShowCourseEnrollModal)
      ? (_openBlock(), _createBlock(_component_CourseEnrollModal, {
          key: 3,
          courseDetails: _ctx.courseDetails,
          onOnContinue: _ctx.onClickPaymentSuccessContinue
        }, null, 8, ["courseDetails", "onOnContinue"]))
      : _createCommentVNode("", true)
  ], 64))
}